/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChatLlmCallDto } from '../../models/chat-llm-call-dto';
import { ChatLlmResponseDto } from '../../models/chat-llm-response-dto';

export interface LlmControllerChatLlm$Params {
  ilsId: string;
      body: ChatLlmCallDto
}

export function llmControllerChatLlm(http: HttpClient, rootUrl: string, params: LlmControllerChatLlm$Params, context?: HttpContext): Observable<StrictHttpResponse<ChatLlmResponseDto>> {
  const rb = new RequestBuilder(rootUrl, llmControllerChatLlm.PATH, 'post');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChatLlmResponseDto>;
    })
  );
}

llmControllerChatLlm.PATH = '/llm/{ilsId}/chatLlm';
